module.exports = __webpack_public_path__ + "vrgroup.c0f568e4ef8e8ece1851.worker.js"